/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

export const livePages = {
    AmpLiveEventDetailPage: () => import('@/blackbolt/liveEvent/LiveEventDetailPage'),
    ConcertDetailPage: () => import('@/concert/ConcertDetailPage'),
    ConcertsPage: () => import('@/concert/ConcertsPage'),
    LiveEventDetailPage: () => import('@/liveevent/LiveEventDetailPage'),
    LiveEventsPage: () => import('@/liveevent/LiveEventsPage'),
}
